<script setup lang="ts">
type Props = Partial<{
  type: string | null
  name: string | null
  data: { label: string; value?: string | null; fullSpan?: boolean }[] | null
  hintText: string | null
}>

defineProps<Props>()
</script>

<template>
  <CardComponent bg="light">
    <template #header>
      <div
        v-if="hintText"
        class="absolute top-0 left-0 rounded-br-lg text-xs bg-primary text-white px-2"
      >
        {{ hintText }}
      </div>
      <div
        class="text-center leading-none flex flex-col justify-center"
        :class="{ 'pt-3': !!hintText }"
      >
        <div
          v-if="type"
          class="text-xs rounded-full text-white"
        >
          — {{ type }} —
        </div>
        <div
          v-if="name"
          class="font-bold text-2xl"
          >{{ name }}
        </div>
        <slot name="header" />
      </div>
    </template>
    <GridComponent
      v-if="data"
      :cols="2"
      gap="lg"
      class="leading-tight p-2"
    >
      <template
        v-for="(item, index) in data"
        :key="index"
      >
        <DataComponent
          :label="item.label"
          :data="item.value"
          :class="{
            'col-span-full': item.fullSpan,
          }"
        />
      </template>
    </GridComponent>
    <slot name="content" />
  </CardComponent>
</template>
